module.exports = __webpack_public_path__ + "static/media/logo.790be3f8.png";